import spring from '../assets/img/illustrations/seasons/spring.png';
import summer from '../assets/img/illustrations/seasons/summer.png';
import autumn from '../assets/img/illustrations/seasons/autumn.png';
import winter from '../assets/img/illustrations/seasons/winter.png';
import springNight from '../assets/img/illustrations/seasons/night/spring.png';
import summerNight from '../assets/img/illustrations/seasons/night/summer.png';
import autumnNight from '../assets/img/illustrations/seasons/night/autumn.png';
import winterNight from '../assets/img/illustrations/seasons/night/winter.png';

/** 产品内置四季插画 · 日间（不可按租户自定义） */
export const SEASONAL_ILLUSTRATIONS = {
	spring,
	summer,
	autumn,
	winter,
};

/** 产品内置四季插画 · 夜间包（深色主题） */
export const SEASONAL_ILLUSTRATIONS_NIGHT = {
	spring: springNight,
	summer: summerNight,
	autumn: autumnNight,
	winter: winterNight,
};

/**
 * 上海气候滞后口径（相对北半球气象季）：
 * 4–5 春，6–9 夏（含秋老虎），10–11 秋，12–3 冬。
 * 本地预览可加查询参数：?season=spring|summer|autumn|winter
 * 强制日/夜包：?seasonPack=day|night
 * @param {Date} [date]
 * @returns {'spring'|'summer'|'autumn'|'winter'}
 */
export function getCurrentSeason(date = new Date()) {
	if (typeof window !== 'undefined') {
		const forced = new URLSearchParams(window.location.search).get('season');
		if (forced && SEASONAL_ILLUSTRATIONS[forced]) return forced;
	}
	const month = date.getMonth() + 1;
	if (month >= 4 && month <= 5) return 'spring';
	if (month >= 6 && month <= 9) return 'summer';
	if (month >= 10 && month <= 11) return 'autumn';
	return 'winter';
}

/**
 * @param {boolean} [isDark]
 * @returns {typeof SEASONAL_ILLUSTRATIONS}
 */
export function getSeasonalIllustrationPack(isDark = false) {
	if (typeof window !== 'undefined') {
		const forcedPack = new URLSearchParams(window.location.search).get('seasonPack');
		if (forcedPack === 'night') return SEASONAL_ILLUSTRATIONS_NIGHT;
		if (forcedPack === 'day') return SEASONAL_ILLUSTRATIONS;
	}
	return isDark ? SEASONAL_ILLUSTRATIONS_NIGHT : SEASONAL_ILLUSTRATIONS;
}

/**
 * @param {Date} [date]
 * @param {{ isDark?: boolean }} [options]
 */
export function getSeasonalIllustrationSrc(date = new Date(), { isDark = false } = {}) {
	const pack = getSeasonalIllustrationPack(isDark);
	return pack[getCurrentSeason(date)];
}
